import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import boltIcon from '@iconify/icons-fa-solid/bolt';
import exchangeAlt from '@iconify/icons-fa-solid/exchange-alt';
import userIcon from '@iconify/icons-fa-solid/user';
import styles from './LiveFeedCard.module.css';

const GAME_NAMES = ['Blackjack', 'Roulette', 'Aviator', 'Sweet Bonanza', 'Gates of Olympus', 'Plinko', 'Mines', 'Baccarat', 'Crash', 'Dragon Tiger'];
const CRYPTO_ICONS = ['BTC', 'ETH', 'USDT', 'LTC', 'DOGE'];
const PAYMENT_METHODS = ['UPI', 'IMPS', 'Bank Transfer', 'NEFT', 'Google Pay', 'PhonePe', 'Paytm'];

const generateWin = () => {
  const game = GAME_NAMES[Math.floor(Math.random() * GAME_NAMES.length)];
  const coin = CRYPTO_ICONS[Math.floor(Math.random() * CRYPTO_ICONS.length)];
  const amount = (Math.random() * 5000 + 10).toFixed(2);
  const multiplier = (Math.random() * 50 + 1.1).toFixed(2);
  const user = `${String.fromCharCode(65 + Math.floor(Math.random() * 26))}***${Math.floor(Math.random() * 99)}`;
  return { id: Date.now() + Math.random(), game, coin, amount, multiplier, user };
};

const generateP2POffer = () => {
  const side = Math.random() > 0.5 ? 'BUY' : 'SELL';
  const rate = side === 'BUY' ? (1 + Math.random() * 0.03).toFixed(3) : (0.97 + Math.random() * 0.03).toFixed(3);
  const amount = Math.floor(Math.random() * 4500 + 50);
  const payment = PAYMENT_METHODS[Math.floor(Math.random() * PAYMENT_METHODS.length)];
  return { id: Date.now() + Math.random(), side, rate, amount, payment };
};

const formatAmount = (num) =>
  Number(num).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const LiveFeedCard = () => {
  const [liveWins, setLiveWins] = useState(() => Array.from({ length: 3 }, generateWin));
  const [p2pOffers, setP2pOffers] = useState(() => Array.from({ length: 3 }, generateP2POffer));
  const [activeTab, setActiveTab] = useState('casino');

  useEffect(() => {
    const interval = setInterval(() => {
      setLiveWins(prev => [generateWin(), ...prev.slice(0, 2)]);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setP2pOffers(prev => [generateP2POffer(), ...prev.slice(0, 2)]);
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.feedCard}>
      {/* Header */}
      <div className={styles.feedHeader}>
        <div className={styles.liveIndicator}>
          <span className={styles.liveDot} />
          <span className={styles.liveLabel}>LIVE</span>
        </div>
        <div className={styles.tabs}>
          <button
            className={`${styles.tab} ${activeTab === 'casino' ? styles.tabActive : ''}`}
            onClick={() => setActiveTab('casino')}
          >
            <Icon icon={boltIcon} className={styles.tabIcon} />
            Live Bets
          </button>
          <button
            className={`${styles.tab} ${activeTab === 'p2p' ? styles.tabActive : ''}`}
            onClick={() => setActiveTab('p2p')}
          >
            <Icon icon={exchangeAlt} className={styles.tabIcon} />
            P2P Offers
          </button>
        </div>
      </div>

      {/* Column labels + rows */}
      {activeTab === 'casino' ? (
        <>
          <div className={styles.colLabels}>
            <span>Player</span>
            <span className={styles.colGame}>Game</span>
            <span>Multi</span>
            <span className={styles.colRight}>Amount</span>
          </div>
          <div className={styles.rows}>
            {liveWins.map((win, i) => (
              <div key={win.id} className={`${styles.row} ${i === 0 ? styles.rowNew : ''}`}>
                <span className={styles.player}>
                  <Icon icon={userIcon} className={styles.playerIcon} />
                  {win.user}
                </span>
                <span className={styles.game}>{win.game}</span>
                <span className={styles.multiplier}>{win.multiplier}x</span>
                <span className={styles.amount}>
                  <span className={styles.coinBadge}>{win.coin}</span>
                  ${formatAmount(win.amount)}
                </span>
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          <div className={styles.colLabels}>
            <span>Type</span>
            <span>Amount</span>
            <span>Rate</span>
            <span className={styles.colRight}>Method</span>
          </div>
          <div className={styles.rows}>
            {p2pOffers.map((offer, i) => (
              <div key={offer.id} className={`${styles.row} ${i === 0 ? styles.rowNew : ''}`}>
                <span className={`${styles.sideBadge} ${offer.side === 'BUY' ? styles.buy : styles.sell}`}>
                  {offer.side}
                </span>
                <span className={styles.p2pAmount}>{offer.amount} <span className={styles.usdt}>USDT</span></span>
                <span className={styles.rate}>@{offer.rate}</span>
                <span className={styles.method}>{offer.payment}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LiveFeedCard;
